import React from "react";
import Confetti from "react-confetti-boom";

const Success = () => {
    return (
        <div className="relative h-full">
            <div className="h-[200px] easycommerece-confetti">
                <Confetti
                    mode="boom"
                    shapeSize={10}
                    particleCount={500}
                    spreadDeg={360}
                    deg={270}
                    colors={["#FF4848", "#FFB400", "#19B1FF", "#7D3BC0"]}
                />
            </div>

            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex justify-center items-center flex-col">
                <h3
                    className="text-[48px] font-normal p-4 font-inter leading-none mb-2"
                    style={{
                        background:
                            "linear-gradient(90deg, #9479FF 0%, #B07FFF 12.5%, #566EEF 37.5%, #8C2BB9 67.5%, #FFBE5B 97%)",
                        backgroundClip: "text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                    }}
                >
                    Congratulations!
                </h3>
                <p className="text-ec-body text-[24px] leading-[32px] font-normal font-inter">
                    Your EasyCommerce store is all set and ready to go!
                </p>
                <a
                    className="bg-transparent mt-8 flex justify-center items-center gap-[8px] font-inter group  border border-ec-primary py-[11px] px-8 rounded-lg text-ec-primary hover:text-white  hover:bg-ec-primary focus:shadow-none focus:text-white focus:bg-ec-secondary  lg:text-sm md:text-xs sm:text-sm transition-all ease-in-out duration-500"
                    href="?page=easycommerce-store"
                >
                    Go to Store
                </a>
            </div>
        </div>
    );
};

export default Success;
